export const Functions = {
  create: true,
  delete: false,
  detail: true,
  search: true,
};

export const PageName = '收货地址管理';
